// import { object, number } from 'yup';
import { useQuery } from '@tanstack/react-query';

import useCredentials from 'api/hook/useCredentials';

import { baseAxios, handleError } from 'api';

/**
 * @typedef {import('yup').InferType<typeof resultScheme>} TResult
 */

export function usePolicies(keyword) {
  const authAxios = useCredentials();

  return useQuery({
    queryKey: ['policies', keyword],
    queryFn: () => baseAxios(authAxios, { url: `/policy?keyword=${keyword}` }),
    onError: (err) => {
      handleError(err);
    },
    initialData: [],
    enabled: false,
    retry: false,
  });
}
